export default "__VITE_ASSET__C6ZUSr7V__"